module.exports = __webpack_public_path__ + "img/Path 27 Copy@3x.b3e3f640.png";